module.exports = __webpack_public_path__ + "static/media/business_taxadvisory.95cd963b.png";